import { render, staticRenderFns } from "./system-info.vue?vue&type=template&id=30b1a3c5&scoped=true&"
import script from "./system-info.vue?vue&type=script&lang=js&"
export * from "./system-info.vue?vue&type=script&lang=js&"
import style0 from "./system-info.vue?vue&type=style&index=0&id=30b1a3c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b1a3c5",
  null
  
)

export default component.exports